"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m9.775 3.143 3.083 3.082 1.885-1.886-3.082-3.082-1.886 1.886Zm3.436 4.143-.012.012-7.045 7.045a.503.503 0 0 1-.282.199L.68 15.932a.501.501 0 0 1-.612-.612l1.391-5.192a.502.502 0 0 1 .2-.283l5.391-5.39.707.706-5.101 5.101 3.082 3.083 6.413-6.413-3.436-3.435a.502.502 0 0 1 0-.708L11.307.196a.516.516 0 0 1 .707 0l3.79 3.79a.5.5 0 0 1 0 .707L13.21 7.286ZM4.777 13.8 2.2 11.223l-.943 3.52 3.52-.943Zm-3.05.466.301-1.13.827.827-1.129.303Zm2.47-3.13.708.708 4.712-4.712-.707-.707-4.712 4.712Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m19.373 9.622-4.975-4.974 3.153-3.153 4.974 4.975-3.152 3.152ZM8.53 20.463l10.046-10.045-2.144-2.145-3.228-3.228a.563.563 0 0 1 0-.795L17.153.302c.22-.22.576-.22.796 0l5.77 5.77a.563.563 0 0 1 0 .796l-3.949 3.948a.457.457 0 0 1-.016.015L9.017 21.568a.562.562 0 0 1-.33.244L.778 23.93a.562.562 0 0 1-.69-.69l2.12-7.907a.564.564 0 0 1 .24-.329l8.22-8.22.796.796-7.908 7.908 4.974 4.974Zm-5.488-3.897L1.43 22.592l6.025-1.615-4.41-4.41Zm-.96 5.358.461-1.719 1.259 1.259-1.72.46Zm4.244-4.964.796.796 7.175-7.175-.795-.796-7.176 7.175Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m25.83 12.83-6.633-6.633 4.204-4.203 6.632 6.633-4.203 4.203ZM11.375 27.284 24.77 13.891l-2.863-2.863-4.3-4.3v-.001a.751.751 0 0 1 0-1.06L22.87.403a.75.75 0 0 1 1.061 0l7.693 7.693a.75.75 0 0 1 0 1.06l-5.264 5.265a.805.805 0 0 1-.02.02L12.022 28.757a.75.75 0 0 1-.441.325L1.039 31.907a.75.75 0 0 1-.919-.919l2.825-10.543a.752.752 0 0 1 .321-.438l10.96-10.96 1.06 1.061L4.743 20.652l6.632 6.632ZM4.058 22.09l-2.153 8.034 8.034-2.154-5.881-5.88Zm-1.28 7.143.614-2.292 1.678 1.678-2.292.614Zm5.658-6.619 1.061 1.061 9.567-9.567-1.06-1.06-9.568 9.566Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m16.928 41.294 20.535-20.536-.313-.313-10.66-10.66h.001a.937.937 0 0 1 0-1.325L34.453.498a.937.937 0 0 1 1.325 0l11.635 11.636a.938.938 0 0 1 0 1.326l-7.949 7.949-.012.012-21.705 21.706a.94.94 0 0 1-.558.417L1.244 47.817A.938.938 0 0 1 .096 46.67l4.272-15.946a.937.937 0 0 1 .42-.56l16.59-16.59 1.326 1.326L6.618 30.985l10.31 10.31ZM38.79 19.433 28.48 9.123l6.636-6.635 10.31 10.309-6.636 6.636ZM5.758 32.777 2.326 45.586l12.809-3.433-9.377-9.376ZM4.193 43.638l.928-3.466L7.66 42.71l-3.466.928Zm7.89-9.009 1.326 1.326 15.009-15.009-1.326-1.325L12.083 34.63Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m22.57 55.059 27.381-27.381-.597-.598L35.32 13.048a1.249 1.249 0 0 1 0-1.768L45.938.665a1.25 1.25 0 0 1 1.767 0l15.514 15.514a1.25 1.25 0 0 1 0 1.768l-10.6 10.598-.016.017-28.94 28.94a1.26 1.26 0 0 1-.744.557L1.658 63.756a1.25 1.25 0 0 1-1.531-1.531l5.697-21.26c.084-.317.287-.582.56-.747l22.12-22.12 1.768 1.768L8.824 41.313 22.57 55.059ZM46.82 3.317l-8.847 8.847L51.719 25.91l8.848-8.847L46.82 3.317ZM7.679 43.702l-4.576 17.08 17.078-4.578L7.678 43.702ZM5.591 58.184l1.238-4.622 3.384 3.384-4.622 1.238Zm10.52-12.012 1.768 1.768L37.89 27.928l-1.768-1.767L16.11 46.172Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconEdit = function IconEdit(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Edit' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Edit"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconEdit.sizes = [16, 24, 32, 48, 64];
IconEdit.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconEdit;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/system/Edit.js
// module id = 2367
// module chunks = 0